<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-renouvellement/"
    paramsName="renouvellement_tableau"
    :endpoint="endpoint"
    showPanier
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component
        :is="path"
        :sas="sas"
        @validation-changed="setState(path, $event)"
        :ref="path"
        :endpoint="endpoint"
      >
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"

import Identification from "@/components/Formulaires/DemandeRenouvellement/Identification"
import ChangementCategorie from "@/components/Formulaires/DemandeRenouvellement/ChangementCategorie"
import LieuxExercice from "@/components/Formulaires/DemandeRenouvellement/LieuxExercice"
import SouscriptionAssurance from "@/components/form_parts/SouscriptionAssurance"
import Communications from "@/components/Formulaires/DemandeRenouvellement/Communications"
import Declarations from "@/components/Formulaires/DemandeRenouvellement/Declarations"
import DeclarationsJudiciaires from "@/components/form_parts/DeclarationsJudiciaires"
import ExerciceDeLaPharmacie from "@/components/Formulaires/DemandeRenouvellement/ExerciceDeLaPharmacie.vue"
import ModeDePaiement from "@/components/form_parts/ModeDePaiement";

export default {
  props: {
    step: String,
  },
  data() {
    return {
      endpoint: "demande-renouvellement",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "changement-categorie", code: "titre-etape-2", state: "" },
        { path: "lieux-exercice", code: "titre-etape-3", state: "" },
        { path: "exercice-de-la-pharmacie", code: "titre-etape-3B", state: "" },
        { path: "souscription-assurance", code: "titre-etape-4", state: "" },
        { path: "communications", code: "titre-etape-5", state: "" },
        { path: "declarations-judiciaires", code: "titre-etape-6", state: "" },
        { path: "declarations", code: "titre-etape-7", state: "" },
        { path: "mode-de-paiement", code: "titre-etape-8", state: "" },
        { path: "soumission", code: "titre-soumission" },
      ],
    }
  },

  components: {
    FormulaireView,
    Identification,
    ChangementCategorie,
    LieuxExercice,
    SouscriptionAssurance,
    Communications,
    DeclarationsJudiciaires,
    Declarations,
    ModeDePaiement,
    ExerciceDeLaPharmacie,
  },
}
</script>

<style></style>